
// 账户页
const account = () => import(/* webpackChunkName: "Index" */ '@/views/accountModule/index')

const accountRouter = [
    {
      path: '/index',
      redirect: '/admin/home',
      component: () => import('@/views/loginModule/index'),
      children: [
        {
          path: '/admin/account',
          name: 'account',
          component: account,
          meta: {
            title: '账户'
          }
        }
      ]
    }
  ]
  export default accountRouter
  
